<template>
    <div class="container-fluid">
        <div class="row">
            <div class="topbg">
                <div class="col-xxl-12">
                    <div class="titlebg">
                        <div class="bigtitle">
                            <a href="/VIP/home" class="bigtitle">
                                <span class="bigfont">V</span>endor
                                <span class="bigfont">I</span>ntegration
                                <span class="bigfont">P</span>ortal{{versionTitle}}
                            </a>
                        </div>
                       
                        <div class="topicon">
                          
                            <router-link :to="'/home'">
                                <i class="bi bi-house topiconbg"></i><span class="stext">Home</span>
                            </router-link> 
                            <a  :href="esg_url"   target="_blank">
                                <img src="images/ESG4.svg" class="topiconbg esgicon" style="margin-top: 0px;width: 35px;">
                                <span class="stext">ESG GO</span>
                            </a>
                             <Dropdown 
                            v-model="selectedLang" 
                            :options="languages" 
                            optionLabel="name" 
                            optionValue="value" 
                            @change="change"
                            style="padding: 0px;margin: 0px;height: 40px;"
                             />
                            <router-link :to="'/profile'" class="link-dark rounded">
                                <i class="bi bi-person topiconbg"></i>{{ user_userName }}
                                 </router-link>

                                 <router-link :to="'/flowList'"  v-if="is_CompalUser==true">
                                    <Badge :value="flowCount"></Badge>
                                </router-link> 

                           <a href="#" @click="logout()"><i class="bi bi-box-arrow-right topiconbg"></i>Log-out</a>
                        </div>

                    </div>
                </div>
                <!--  左側伸縮選單   -->
                <Menu  v-if="Type!='BS' "></Menu>
            </div>

            <div class="col-xxl-12 " style="background-color: #dee1de;border-top: #FFF 4px solid;" v-if="$route.path!=='/home' && $route.path!=='/' && $route.path!=='/index.html'">
                <div class="innertitle">{{ $t(t_path) }}</div>
            </div>

            


        </div> <!--  最外層 row  -->
    </div> <!--  container-fluid  -->
                
            


</template>
  
<script>
 import Menu from './Menu.vue'
import CommonService from "@/service/CommonService";
export default {
    name: 'Header',
    components: {
    // ApplyPage,
    Menu,
  
  },
    data() {
        return {
            versionTitle:'',
            title:'',
            t_path:'',  
            selectedLang:'en',
            languages: [
                {
                    name:'English',
                    value:'en'
                },
                {
                    name:'繁體中文版',
                    value:'zh-TW'
                },
                {
                    name:'简体中文版',
                    value:'zh-CN'
                },
            ],

             
           
        }
    },
    watch: {
    $route(to) {
      //  console.log(to);
      //  console.log(from);
        this.showTitle(to.path)
    }
    },
    CommonService:null,
    variables:null,
       created(){
        this.CommonService= new CommonService();
      
         
       
     /*    if(this.culture){
            this.selectedCity=this.culture;
            this.setLang(this.selectedCity);
        }
         */

    },
    mounted(){
        if(this.culture){
            this.selectedLang=this.culture;
            this.setLang(this.selectedLang);
        }
        if('development'==this.CommonService.GetHeaderTitle())
        {
            this.versionTitle='(開發環境)'
            this.$store.commit("Set_Plafotrm", 'development');
        }
        else if('test'==this.CommonService.GetHeaderTitle())
        {
            this.versionTitle='(測試環境)'
            this.$store.commit("Set_Plafotrm", 'test');
        }
        else if('qas'==this.CommonService.GetHeaderTitle())
        {
            this.versionTitle='(測試環境)'
            this.$store.commit("Set_Plafotrm", 'qas');
        }
        else
        {
            this.$store.commit("Set_Plafotrm", 'prd');
        }
        
    },
    computed: {
    isLoading() {
      return this.$store.state.isLoading;
      //return false;
    },
    esg_url() {
      return 'https://www.compal.com/esg/go/?email='+ this.user_email;
     },
    user() {
     return this.$store.state.user;
    },
    user_email() {
     return this.$store.state.user?.email;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_buyerMapping() {
     return this.$store.state.user?.buyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.sourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.vendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },
    flowCount() {
      return this.$store.state.flowcount;
    },

    is_VIPAdmin(){
       return this.user_roles && this.user_roles.includes('VIPAdmin');
    },
    is_SCSI(){
       return this.user_roles && this.user_roles.includes('SCSI');
    },
    is_Sourcer(){
       return this.user_roles && this.user_roles.includes('Sourcer');
    },
    is_Buyer(){
       return this.user_roles && this.user_roles.includes('Buyer');
    },
    is_CompalUser(){
       return this.user_roles && this.user_roles.includes('CompalUser');
    },
    is_VendorUser(){
       return this.user_roles && this.user_roles.includes('VendorUser');
    },
    is_Supervisor(){
       return this.user_roles && this.user_roles.includes('Supervisor');
    },
      Type() {
     return this.$store.state.user?.Type;
    },
    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },
    culture() {
     return this.$store.state.user?.Culture;
    },

     

  },
    methods: {
        showTitle(path){
           /*  console.log(path);
            console.log(this.$t("title./flowList"));
            console.log(this.$t("title."+path)); */
    
            if(path)
            {
                if(path.includes('/'))
                {
                    var arr= path.split('/');
                    var t=arr[1];
                   /*  console.log('arr.................')
                    console.log(arr)
                    console.log(t) */
                    this.title = this.$t("title./"+t);
                    this.t_path="title./"+t;
                }
                else {
                    this.title = this.$t("title."+path);
                    this.t_path="title."+path;
                }
            }

          
        },
        home() {
            this.$router.push({
                name: 'home'
            });
        },
        logout(){

            this.$cookies.remove("vip_token");
            this.$cookies.remove("vip_refreshToken");
            this.$cookies.remove("vip_sessionCode");
            this.$cookies.remove("cps_token");
            this.$cookies.remove("cps_refreshToken");
            this.$cookies.remove("cps_sessionCode");
            this.$cookies.remove("rfq_token");
            this.$cookies.remove("rfq_refreshToken");
            this.$cookies.remove("rfq_sessionCode");


            this.$store.commit("Set_Token", null);
            this.$store.commit("Set_RefreshToken", null);
            this.$store.commit("Set_SessionCode", null);
            this.$store.commit("Set_User", null);
            if(confirm('登出?'));
            setTimeout(() => {
                this.$router.replace("/logout");
            }, 50);
        },

        change() {
           // console.log(event)
            this.setLang ()
            this.updateLang () 
        },
        setLang () {
            this.$i18n.locale = this.selectedLang;
            this.$store.commit("Set_Language", this.selectedLang);
         },
        updateLang () {
            
                if(this.selectedLang){
                    this.CommonService.UpadteUserLocales(this.selectedLang).then(()=>{
                           // console.log(x);
                        })
                }
           

        }
    }

}

/* Loop through all dropdown buttons to toggle between hiding and showing its dropdown content - This allows the user to have multiple dropdowns without any conflict */
var dropdown = document.getElementsByClassName("dropdown-btn");
var i;

for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var dropdownContent = this.nextElementSibling;
    if (dropdownContent.style.display === "block") {
      dropdownContent.style.display = "none";
    } else {
      dropdownContent.style.display = "block";
    }
  });
}

</script>
<style scoped>
.bigtitle {
    margin-left: 35px;
    z-index: 20;
    cursor: pointer;
    color: #FFF;
}
 
</style>
 